import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Goalsmobius() {
  return (
    <section className="goals_mobius p-100" style={{ background: "#FAFAFA" }}>
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2 style={{ color: "#000" }}>
              <span style={{ color: "#214092" }}>Project Goals and </span>
              Collaboration with TekRevol
            </h2>
            <p>
              The key goal of collaborating with TekRevol was to develop robust
              and user-friendly mobile apps that followed Mobius Risk Group's
              traditional ERP system.
            </p>
            <p>
              TekRevol worked carefully with Mobius Risk Group to comprehend
              their detailed needs and guarantee faultless integration of the
              ERP functionalities into the mobile apps.
            </p>
            <p>
              The association was intended to empower Mobius Risk Group with a
              mobile solution that would enhance their risk management
              capabilities.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto text-center"
          >
            <StaticImage
              src="../../../images/case-studies/mobius/project_goals.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={749}
              height={516}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Goalsmobius;
